import { NoteState } from "@/core/types";

const COMPLETED_STATES: NoteState[] = ["complete", "completed"];

export function isNoteCompleted(state: NoteState) {
  return COMPLETED_STATES.includes(state);
}
